module.exports = __webpack_public_path__ + "static/media/testfile_layerSceneCompletion.35de79da.zip";